import type { Matcher } from 'react-day-picker';

import { Button } from '@connected/ui/components/button';
import { Calendar } from '@connected/ui/components/calendar';
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from '@connected/ui/components/popover';
import { cn } from '@connected/ui/lib/utils';
import { format } from 'date-fns';
import { nl } from 'date-fns/locale';
import { Calendar as CalendarIcon, ChevronDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { HandleChange } from './types';

type DateFieldProps = {
    value: Date;
    onChange: HandleChange<Date>;
    disabled?: Matcher | Matcher[] | undefined;

};

export function DateField({ value, onChange, disabled = false }: DateFieldProps) {
    const { t } = useTranslation('common');

    const date = new Date(value);

    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button
                    variant="outline"
                    className={cn(
                        'w-full justify-between gap-2 text-left font-normal',
                        !date && 'text-muted-foreground',
                    )}
                    disabled={disabled === true}
                >
                    <CalendarIcon />
                    <span className="w-full min-w-[140px]">
                        {date
                            ? format(date, 'PPP', { locale: nl })
                            : t('date-field.placeholder')}
                    </span>
                    <ChevronDown />
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0">
                <Calendar
                    mode="single"
                    selected={date}
                    onSelect={data => data && onChange(data)}
                    locale={nl}
                    // {...(disabled ? { disabled: true } : { disabled: { before: new Date() } })}
                    disabled={disabled}
                />
            </PopoverContent>
        </Popover>
    );
}
